
/**
 * This file is auto-generated. Do not modify directly.
 */

/* tslint:disable */
export type DayOfWeekNames = {
  sun: string;
  mon: string;
  tue: string;
  wed: string;
  thu: string;
  fri: string;
  sat: string;
};

export type LocaleDataType = {
  firstDayOfWeek: keyof DayOfWeekNames;
  prefer24HourTimeCycle: boolean;
  abbreviatedDayNames: DayOfWeekNames;
  narrowDayNames: DayOfWeekNames;
  shortDayNames: DayOfWeekNames;
  wideDayNames: DayOfWeekNames;
};

export type LocalizeFormat = {
  localeData: LocaleDataType,
  formatRelativeTime: any,
  formatBestFitRelativeTime: any,
  formatUnit: any,
  formatDate: any,
  formatNumber: any
  parseDate: any,
  parseNumber: any,
  currentLocale: string, // FormatLocale
};

export type LocalizeMessage = {
  currentLocale: string; // MessageLocale;
};

interface Localize {
  msg: any, format: LocalizeFormat, message: LocalizeMessage
}
declare const CustomLocalizeNamespace: string;

declare const process: {
  release?: {
    name?: string
  }
};

/* istanbul ignore next */
function getLocalize() {
  let globalContainer;
  if (typeof process !== 'undefined' && typeof process.release !== 'undefined' && process.release.name === 'node') {
    globalContainer = global;
  } else {
    //@ts-ignore
    globalContainer = self;
  }

  let localizeNamespace = globalContainer as any;

  if (typeof CustomLocalizeNamespace === 'string') {
    localizeNamespace = (globalContainer as any)[CustomLocalizeNamespace];
  }

  if (typeof localizeNamespace.Localize === 'undefined') {
    throw Error('The messages.<locale>.js file has not been loaded');
  }

  return localizeNamespace.Localize as Localize;
};

/* istanbul ignore next */
export let getLocalizeFormat = () => {
  const localize = getLocalize();
  if (localize.format === undefined) {
    throw Error('The formatters-and-parsers.<locale>.js file has not been loaded');
  }
  return localize.format;
};

/* istanbul ignore next */
export let getCurrentMessageLocale = () => {
  const localize = getLocalize();
  if (localize.message.currentLocale === undefined) {
    throw Error('The localize.message.currentLocale has not been set');
  }
  return localize.message.currentLocale;
};


/* istanbul ignore next */
export const LocaleData = { get: () => getLocalizeFormat().localeData };

/* istanbul ignore next */
export const CurrentMessageLocale = { get: () => getCurrentMessageLocale() };
const t = (k: string, a?: any): string => getLocalize().msg.formatMessage(k, a);
export const Messages = {
  bold: () => t('@tableau__widgets/bold'),
  cancel: () => t('@tableau__widgets/cancel'),
  close: () => t('@tableau__widgets/close'),
  closeDialog: () => t('@tableau__widgets/closeDialog'),
  customColor: () => t('@tableau__widgets/customColor'),
  edit: () => t('@tableau__widgets/edit'),
  editorMode: () => t('@tableau__widgets/editorMode'),
  enterValidDate: () => t('@tableau__widgets/enterValidDate'),
  errorToastPrefix: () => t('@tableau__widgets/errorToastPrefix'),
  formattingGuide: () => t('@tableau__widgets/formattingGuide'),
  formattingHintsBold: () => t('@tableau__widgets/formattingHintsBold'),
  formattingHintsColumnExample: () => t('@tableau__widgets/formattingHintsColumnExample'),
  formattingHintsColumnMarkup: () => t('@tableau__widgets/formattingHintsColumnMarkup'),
  formattingHintsImage: () => t('@tableau__widgets/formattingHintsImage'),
  formattingHintsItalics: () => t('@tableau__widgets/formattingHintsItalics'),
  formattingHintsLink: () => t('@tableau__widgets/formattingHintsLink'),
  formattingHintsUnderline: () => t('@tableau__widgets/formattingHintsUnderline'),
  heading1: () => t('@tableau__widgets/heading1'),
  heading2: () => t('@tableau__widgets/heading2'),
  heading3: () => t('@tableau__widgets/heading3'),
  infoToastPrefix: () => t('@tableau__widgets/infoToastPrefix'),
  italics: () => t('@tableau__widgets/italics'),
  keyboardModifierCtrl: () => t('@tableau__widgets/keyboardModifierCtrl'),
  keyboardModifierShift: () => t('@tableau__widgets/keyboardModifierShift'),
  link: () => t('@tableau__widgets/link'),
  linkText: () => t('@tableau__widgets/linkText'),
  linkUrl: () => t('@tableau__widgets/linkUrl'),
  nextMonth: () => t('@tableau__widgets/nextMonth'),
  noMatches: () => t('@tableau__widgets/noMatches'),
  optional: () => t('@tableau__widgets/optional'),
  optionsSelected: (a: {COUNT: string}) => t('@tableau__widgets/optionsSelected', a),
  orderedList: () => t('@tableau__widgets/orderedList'),
  paragraph: () => t('@tableau__widgets/paragraph'),
  preview: () => t('@tableau__widgets/preview'),
  previousMonth: () => t('@tableau__widgets/previousMonth'),
  remove: () => t('@tableau__widgets/remove'),
  required: () => t('@tableau__widgets/required'),
  successToastPrefix: () => t('@tableau__widgets/successToastPrefix'),
  skeletonLoaderLabel: () => t('@tableau__widgets/skeletonLoaderLabel'),
  textEditorDisabledPreviewMode: () => t('@tableau__widgets/textEditorDisabledPreviewMode'),
  textileLinkText: () => t('@tableau__widgets/textileLinkText'),
  textilePreviewLabel: () => t('@tableau__widgets/textilePreviewLabel'),
  tooltipAnchorAlt: () => t('@tableau__widgets/tooltipAnchorAlt'),
  underline: () => t('@tableau__widgets/underline'),
  unorderedList: () => t('@tableau__widgets/unorderedList'),
  waitIndicatorLabel: () => t('@tableau__widgets/waitIndicatorLabel'),
  warningToastPrefix: () => t('@tableau__widgets/warningToastPrefix'),
  weekNumber: (a: {weekNum: string}) => t('@tableau__widgets/weekNumber', a),
  optionCountAnnouncement: (a: {optionCount: number, formattedOptionCount: string}) => t('@tableau__widgets/optionCountAnnouncement', a),
};
export const Formatters = {
  formatFullMonthAndFullYear: (a: Date): string => getLocalizeFormat().formatDate(a, {"skeleton":"yyyyMMMM"}),
  formatNarrowDayOfWeek: (a: Date): string => getLocalizeFormat().formatDate(a, {"skeleton":"EEEEE"}),
  formatShortDate: (a: Date): string => getLocalizeFormat().formatDate(a, {"date":"short"}),
  formatMediumDate: (a: Date): string => getLocalizeFormat().formatDate(a, {"date":"medium"}),
  formatLongDate: (a: Date): string => getLocalizeFormat().formatDate(a, {"date":"long"}),
  formatFullDate: (a: Date): string => getLocalizeFormat().formatDate(a, {"date":"full"}),
  formatShortDateTime: (a: Date): string => getLocalizeFormat().formatDate(a, {"datetime":"short"}),
  formatMediumDateTime: (a: Date): string => getLocalizeFormat().formatDate(a, {"datetime":"medium"}),
  formatLongDateTime: (a: Date): string => getLocalizeFormat().formatDate(a, {"datetime":"long"}),
  formatFullDateTime: (a: Date): string => getLocalizeFormat().formatDate(a, {"datetime":"full"}),
  formatShortDateWithFullYear: (a: Date): string => getLocalizeFormat().formatDate(a, {"skeleton":"yyyyMd"}),
  formatShortDateTimeWithFullYear: (a: Date): string => getLocalizeFormat().formatDate(a, {"skeleton":"yyyyMdhm"}),
  formatShortDateTimeWithFullYear24Hour: (a: Date): string => getLocalizeFormat().formatDate(a, {"skeleton":"yyyyMdHm"}),
  formatShortDateMediumTimeWithFullYear: (a: Date): string => getLocalizeFormat().formatDate(a, {"skeleton":"yyyyMdhms"}),
  formatShortDateMediumTimeWithFullYear24Hour: (a: Date): string => getLocalizeFormat().formatDate(a, {"skeleton":"yyyyMdHms"}),
  formatCount: (a: number): string => getLocalizeFormat().formatNumber(a, {"maximumFractionDigits":0}),
};
export const Parsers = {
  parseShortDate: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"date":"short"}),
  parseMediumDate: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"date":"medium"}),
  parseLongDate: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"date":"long"}),
  parseFullDate: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"date":"full"}),
  parseShortDateTime: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"datetime":"short"}),
  parseMediumDateTime: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"datetime":"medium"}),
  parseLongDateTime: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"datetime":"long"}),
  parseFullDateTime: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"datetime":"full"}),
  parseShortDateWithFullYear: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"skeleton":"yyyyMd"}),
  parseShortDateTimeWithFullYear: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"skeleton":"yyyyMdhm"}),
  parseShortDateTimeWithFullYear24Hour: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"skeleton":"yyyyMdHm"}),
  parseShortDateMediumTimeWithFullYear: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"skeleton":"yyyyMdhms"}),
  parseShortDateMediumTimeWithFullYear24Hour: (a: string): Date | null => getLocalizeFormat().parseDate(a, {"skeleton":"yyyyMdHms"}),
};
